import React from 'react';

// Placeholder shapes shown while Firestore content loads, so screens keep
// their layout instead of collapsing to a spinner. Respects dark mode.

const block = 'bg-gray-200 dark:bg-gray-700 rounded';

/** A list-row card: icon square, two text lines, chevron. Matches the hospital / topic cards. */
export const SkeletonRow = ({ className = '' }) => (
  <div className={`w-full bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-700 rounded-xl p-4 flex items-center gap-4 animate-pulse ${className}`}>
    <div className={`${block} w-11 h-11 rounded-xl flex-shrink-0`} />
    <div className="flex-1 space-y-2">
      <div className={`${block} h-4 w-2/3`} />
      <div className={`${block} h-3 w-1/2`} />
    </div>
    <div className={`${block} w-4 h-4 rounded-full`} />
  </div>
);

/** A wide featured-carousel card. */
export const SkeletonFeaturedCard = () => (
  <div className="flex-shrink-0 w-72 h-40 bg-gray-200 dark:bg-gray-700 rounded-2xl animate-pulse" />
);

/** Several rows with a heading line, for a content list. */
export const SkeletonList = ({ rows = 3, withHeading = false }) => (
  <div className="space-y-3" aria-busy="true" aria-label="Loading">
    {withHeading && <div className={`${block} h-5 w-40 mb-3 animate-pulse`} />}
    {Array.from({ length: rows }).map((_, i) => <SkeletonRow key={i} />)}
  </div>
);
